var BrowseContentHelper, DealsApplication, DealsGTMHelper, DealsSearchParamsHelper, Page, performSearch, updateSeoPageMetaHash,
  slice = [].slice,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

DealsSearchParamsHelper = require('./helpers/search_params');

DealsGTMHelper = require('./helpers/gtm-update');

BrowseContentHelper = require('../../browse/frontend/helpers/content');

updateSeoPageMetaHash = require('../../seo/frontend/page_meta_updater').updateSeoPageMetaHash;

Page = (function() {
  function Page(pageNumber, data) {
    var paginationData, ref, ref1, ref2, ref3;
    paginationData = data.metadata.pagination || {};
    _.extend(this, {
      clearanceDealsCount: data.clearanceDealsCount,
      countHtml: paginationData.countHtml,
      totalDealCount: paginationData.availableCount,
      bloodhoundHtml: paginationData.bloodhoundHtml,
      deals: (ref = data.dealContent) != null ? ref.deals : void 0,
      dealCount: paginationData.dealsCount,
      dealIdList: ((ref1 = data.metadata) != null ? (ref2 = ref1.pagination) != null ? ref2.dealIdList : void 0 : void 0) || [],
      dealsHtml: data.dealsHtml,
      hasFeaturedDeal: (ref3 = data.dealContent) != null ? ref3.hasFeaturedDeal : void 0,
      featuredHtml: data.featuredHtml,
      carouselHtml: data.carouselHtml,
      topDealsHtml: data.topDealsHtml,
      nextPageSize: paginationData.nextPageSize,
      number: pageNumber,
      totalPages: paginationData.totalPages,
      facets: data.metadata.facets,
      firstDeal: data.metadata.firstDeal,
      startingIndex: paginationData.startingIndex,
      endingIndex: paginationData.endingIndex,
      refinementUiPageData: data.refinementUiPageData,
      cardsHtml: data.cardsHtml,
      seoMetaHash: data.seoMetaHash,
      breadcrumbHash: data.breadcrumbHash
    });
  }

  return Page;

})();

performSearch = function(params) {
  var ref, search;
  if (params == null) {
    params = {};
  }
  if ((ref = this.xhr) != null) {
    ref.abort();
  }
  this.xhr = $.ajax({
    url: '/goods/deals/partial',
    data: params
  });
  search = _.clone(Backbone.Events);
  this.xhr.done(_(search.trigger).bind(search, 'success'));
  this.xhr.fail((function(_this) {
    return function(xhr, textStatus) {
      if (textStatus !== "abort") {
        return search.trigger('error');
      }
    };
  })(this));
  this.xhr.always(function() {
    search.trigger.apply(search, ['complete'].concat(slice.call(arguments)));
    return search.off();
  });
  return {
    on: _(search.once).bind(search)
  };
};

module.exports = DealsApplication = (function() {
  function DealsApplication(options) {
    var dealsSearch;
    if (options == null) {
      options = {};
    }
    this._triggerSuccessHandler = bind(this._triggerSuccessHandler, this);
    this._triggerErrorHandler = bind(this._triggerErrorHandler, this);
    this._events = _.extend({}, Backbone.Events);
    this.params = DealsSearchParamsHelper.getBaseParams(options);
    this._searchedServerSide = false;
    this._pageNumber = isNaN(Number(this.params.page)) ? 1 : Number(this.params.page);
    if (!/^\d+$/.test(this.params.minPrice)) {
      delete this.params.minPrice;
    }
    if (!/^\d+$/.test(this.params.maxPrice)) {
      delete this.params.maxPrice;
    }
    if ((this.params.minPrice != null) && (this.params.maxPrice != null) && parseInt(this.params.minPrice, 10) > parseInt(this.params.maxPrice, 10)) {
      delete this.params.minPrice;
      delete this.params.maxPrice;
    }
    if (!options.pageData) {
      if (options.pageNumber != null) {
        _.extend(this.params, {
          page: options.pageNumber
        });
        this._pageNumber = options.pageNumber;
      }
      this._dealsCount = options.dealsCount;
      this._startingIndex = options.startingIndex;
      dealsSearch = performSearch(this.params);
      dealsSearch.on('error', this._triggerErrorHandler);
      dealsSearch.on('success', this._triggerSuccessHandler);
    } else {
      this.page = new Page(this._pageNumber, options.pageData);
      this._searchedServerSide = true;
      null;
    }
  }

  DealsApplication.prototype.on = function(event, callback) {
    return this._events.on(event, callback);
  };

  DealsApplication.prototype.unfilteredParams = function() {
    return unfilteredParams(this.params);
  };

  DealsApplication.prototype.getPageNumber = function() {
    var ref;
    return ((ref = this.page) != null ? ref.number : void 0) || this._pageNumber;
  };

  DealsApplication.prototype.getDealsCount = function() {
    var ref;
    return ((ref = this.page) != null ? ref.dealCount : void 0) || this._dealsCount;
  };

  DealsApplication.prototype.getDealAt = function(index) {
    var deals, ref, selectIndex;
    if (!((this.page != null) && (ref = this.page, deals = ref.deals, ref))) {
      return {};
    }
    selectIndex = this.page.hasFeaturedDeal ? Math.max(0, index - 1) : index;
    return {
      deal: deals[selectIndex],
      index: selectIndex
    };
  };

  DealsApplication.prototype.getStartingIndex = function() {
    var ref;
    return ((ref = this.page) != null ? ref.startingIndex : void 0) || this._startingIndex;
  };

  DealsApplication.prototype.nextPage = function() {
    return new this.constructor({
      params: this.params,
      pageNumber: this._pageNumber + 1
    });
  };

  DealsApplication.prototype._triggerErrorHandler = function() {
    var resetButton;
    if (Groupon.categoryAttributeWhitelistRemoval && Groupon.browseApp.lastUpdatedRefinementId === 'category' && (resetButton = $('#clear-module')).is(':visible')) {
      return resetButton.click();
    } else {
      this._events.trigger('error');
      return this._events.stopListening();
    }
  };

  DealsApplication.prototype._triggerSuccessHandler = function(arg, textStatus) {
    var deals, ref, ref1, seoMetaHash;
    deals = (arg != null ? arg : {}).deals;
    if (textStatus !== 'success') {
      return this._triggerErrorHandler();
    } else {
      this.page = new Page(this._pageNumber, deals);
      Groupon.pagination = (ref = deals.metadata) != null ? ref.pagination : void 0;
      this._events.trigger('success', deals);
      this._events.stopListening();
      if (this.params) {
        DealsGTMHelper.update(this.params);
      }
      if (((ref1 = Groupon.enabledFeatures) != null ? ref1.isSEOMetadataEnabled : void 0) && (seoMetaHash = this.page.seoMetaHash)) {
        return updateSeoPageMetaHash(seoMetaHash);
      }
    }
  };

  DealsApplication.prototype.isEmptySearch = function() {
    var ref;
    return ((ref = this.page) != null ? ref.totalDealCount : void 0) === 0;
  };

  DealsApplication.prototype.isSearchedServerSide = function() {
    return this._searchedServerSide;
  };

  return DealsApplication;

})();

//# sourceMappingURL=data:application/json;base64,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
